/* eslint-disable no-template-curly-in-string */
import validate from 'helper/validate.js'
import { setLocale } from 'yup'
import * as Yup from 'yup'

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

setLocale({
  mixed: {
    default: 'Não é válido',
  },
  array: {
    min: 'Selecione pelo menos ${min} ',
  },
})

export const schemaNewGestor = (rule: boolean, isRegisteringPF: boolean) =>
  Yup.object().shape({
    name: Yup.string().required('Campo obrigatório'),
    document: Yup.string()
      .required('Campo obrigatório')
      .test('is-valid-document', 'Documento inválido', (value, context) => {
        if (isRegisteringPF) {
          // Validar CPF
          if (!validate.numbers.cpf(value)) {
            return context.createError({ message: 'CPF inválido' })
          }
        } else if (!validate.numbers.cnpj(value)) {
          // Validar CNPJ
          return context.createError({ message: 'CNPJ inválido' })
        }
        return true
      }),
    nickname: Yup.string().when([], {
      is: () => !isRegisteringPF,
      then: Yup.string().required('Campo obrigatório'),
      otherwise: Yup.string().notRequired(),
    }),
    profilePic: Yup.mixed().required('Campo obrigatório'),
    email: Yup.string()
      .matches(emailRegex, 'Email não é válido')
      .required('Campo obrigatório'),
    cellphone: Yup.string().min(15).max(15).required('Campo obrigatório'),
    superiorId: Yup.object().when([], {
      is: () => rule,
      then: Yup.object().required('Campo obrigatório'),
      otherwise: Yup.object(),
    }),
    // comission: Yup.array().min(1).required('Campo obrigatório'),
    level: Yup.string().required('Escolha um limite de acesso'),
  })

export const comissoes = [
  {
    label: 'Sem Comissionamento',
    value: 'Sem Comissionamento',
  },
  {
    label: 'Comissão de Vendas',
    value: 'Comissão de Vendas',
  },
  {
    label: 'Gestão de carteira',
    value: 'Gestão de carteira',
  },
  {
    label: 'Meta de Equipe',
    value: 'Meta de Equipe',
  },
]

export const levels = [
  ['profile.svg', 'Especialista', `[0, 0, 1, 0, 0, 0, 0, 0, 0]`],
  ['users.svg', 'Gestor e Especia.', `[0, 0,1, 0, 1, 0, 0, 0, 0]`],
  ['users.svg', 'Gestor', '[0, 0, 0, 0, 1, 0, 0, 0, 0]'],
  ['users.svg', 'Diretor', '[0, 0, 0, 1, 0, 0, 0, 0, 0]'],
  ['dollar.svg', 'Financeiro', '[0, 0, 0, 0, 0, 1, 0, 0, 0]'],
  ['dollar.svg', 'Analista de pagamento', '[1, 0, 0, 0, 0, 0, 0, 0, 0]'],
  ['dollar.svg', 'Analista de contrato', '[0, 1, 0, 0, 0, 0, 0, 0, 0]'],
  ['file.svg', 'Jurídico', '[0, 0, 0, 0, 0, 0, 1, 0, 0]'],
  ['volume.svg', 'RI', '[0, 0, 0, 0, 0, 0, 0, 1, 0]'],
  ['settings.svg', 'Gestão usuários', '[0, 0, 0, 0, 0, 0, 0, 0, 1]'],
  ['users.svg', 'Owner', '[1, 1, 1, 1, 1, 1, 1, 1, 1]'],
]
